import { memo } from 'react';

import MainHeaderTitle from '../MainHeaderTitle';
import SearchVacancies from '../SearchVacancies/SearchVacancies';
import classes from './main-hero-block.module.scss';

interface HeroBlock {
  bgImage?: string| undefined;
}

function MainHeroBlock({ bgImage }:HeroBlock) {
  return (
    <>
      <MainHeaderTitle bgImage={bgImage} />

      <div className={classes['main-hero_search']}>
        <SearchVacancies />
      </div>
    </>
  );
}

export default memo(MainHeroBlock);
